var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 7.82353 27.1765 -1.18792e-06 17.5 -7.64949e-07C7.82353 -3.41977e-07 3.41977e-07 7.82353 7.64949e-07 17.5C1.18792e-06 27.1765 7.82353 35 17.5 35C27.1765 35 35 27.1765 35 17.5ZM2.05882 17.5C2.05882 8.95588 8.95588 2.05882 17.5 2.05882C26.0441 2.05882 32.9412 8.95588 32.9412 17.5C32.9412 26.0441 26.0441 32.9412 17.5 32.9412C8.95588 32.9412 2.05882 26.0441 2.05882 17.5Z",
    fill: "#8E7861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2502 26.0441L10.7061 17.4999L19.2502 8.95583L17.809 7.51465L7.82373 17.4999L17.809 27.4852L19.2502 26.0441Z",
    fill: "#8E7861"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26465 16.4707L9.26465 18.5295L26.7646 18.5295L26.7646 16.4707L9.26465 16.4707Z",
    fill: "#8E7861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.2184f83dbf8e3da6762558cef5d79a03.svg";
export { ForwardRef as ReactComponent };